module.exports = __webpack_public_path__ + "static/media/alert-yellow.f6c99e63.svg";